import { CPS_LOCALE } from '../models/CpsLocale';

export const LOCALE_MAPPING = {
  'en-GB': 'en',
  'pl-PL': 'pl',
  'ro-RO': 'ro',
  'et-EE': 'et',
  'nl-NL': 'nl',
  'fr-FR': 'fr',
  'hr-HR': 'hr'
} as const;

export const DEFAULT_ROWS_PER_PAGE = 100;
export const DEFAULT_COLUMN_WIDTH = 200;
export const MIN_COLUMN_WIDTH = 50;
export const MAX_COLUMN_WIDTH = 1000;
export const COLUMN_WIDTH_STEP = 50;
export const GRID_PAGE_SIZES = [100, 200, 300];
export const DEFAULT_NUMERIC_TEXTBOX_STEP = 50;

export const DEFAULT_FACETS_COUNT = 10;
export const MIN_FACETS_COUNT = 1;
export const MAX_FACETS_COUNT = 100;
export const MAX_BULK_PASTE_COUNT = 500;

export const PRIVATE_VIEW_NAME_MIN = 2;
export const PRIVATE_VIEW_NAME_MAX = 30;
export const GLOBAL_FILTERS_LIMIT_MIN = 0;
export const GLOBAL_FILTERS_LIMIT_MAX = 10;
export const MULTI_FILE_UPLOAD_LIMIT_MIN = 0;
export const MULTI_FILE_UPLOAD_LIMIT_MAX = 10;
export const EMPTY_VALUE = '';

export const EXTENSION_FIELD = 'Cps_Extension';
export const DOC_ID_FIELD = 'Cps_DocId';
export const CONTENT_TYPE_FIELD = 'Cps_ContentType';
export const LOCKED_FIELD = 'Cps_Locked';
export const PERMISSIONS_FIELD = 'Cps_Permissions';
export const FILE_FIELD = 'file';
export const ENGLISH_LOCALE = 'en-GB';
export const NEW_DOCUMENT = 'new';

export const USER_LOCALE_SETTINGS_KEY = 'GearUserLocale';
export const USER_INDEX_SETTINGS_KEY = 'GearUserIndex';
export const USER_VIEW_SETTINGS_KEY = 'UserSelectedView';
export const GLOBAL_FILTERS_LIMIT_KEY_PREFIX = 'globalFilterLimitForIndex_';
export const MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX = 'multiFileUploadLimitForIndex_';
export const ABOUT_PAGE_SETTINGS_KEY = 'about';
export const DEFAULT_LOCALE = CPS_LOCALE.enGB;
export const MAX_ITEMS_LIMIT_EXPORT_CSV = 100000;
export const TOO_MANY_REQUESTS_EXPORT_CSV = 30; // in seconds

export const DEFAULT_ABOUT_CONTENT =
  '<h2>About Our Platform</h2><p>Welcome to our platform. We are dedicated to providing the best service possible.</p><p>Our team works around the clock to ensure your experience is seamless and productive.</p>';
export const ABOUT_ADDED_TEXT = 'Encountered a problem? Let us know by reporting the issue here';
export const REPORT_ISSUE_BUTTON_LABEL = 'Report Issue';

export const RICH_TEXT_CHARACTER_LIMIT = 63999;

export const DEFAULT_RETRY_COUNT = 3;

export const LARGE_FILE_THRESHOLD = 49 * 1024 * 1024; // 49MB
export const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
export const MIN_CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_CHUNK_SIZE = LARGE_FILE_THRESHOLD;
export const DEFAULT_UPLOAD_TIMEOUT = 600000;

export const SEARCHABLE_FIELD_DEFAULT_PAGE = 1;
export const SEARCHABLE_FIELD_DEFAULT_PAGE_SIZE = 30;
export const SEARCHABLE_FIELD_DEFAULT_DEBOUNCE_TIMER = 300; // 300ms

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark'
} as const;
